/* tslint:disable */
/* eslint-disable */
/**
 * Vocalise.API.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  DashboardDto,
  Exercise,
  ExerciseDTO,
  GoalDto,
  StreaksDto,
} from '../models/index';
import {
    DashboardDtoFromJSON,
    DashboardDtoToJSON,
    ExerciseFromJSON,
    ExerciseToJSON,
    ExerciseDTOFromJSON,
    ExerciseDTOToJSON,
    GoalDtoFromJSON,
    GoalDtoToJSON,
    StreaksDtoFromJSON,
    StreaksDtoToJSON,
} from '../models/index';

export interface ApiExerciseDashboardInfoGetRequest {
    yearWeek?: number;
}

export interface ApiExerciseGoalGetRequest {
    yearWeek?: number;
}

export interface ApiExerciseGoalPostRequest {
    value: number;
}

export interface ApiExercisePostRequest {
    exerciseDTO: ExerciseDTO;
}

export interface ApiExerciseWeekGetRequest {
    yearWeek?: number;
}

/**
 * 
 */
export class ExerciseApi extends runtime.BaseAPI {

    /**
     */
    async apiExerciseDashboardInfoGetRaw(requestParameters: ApiExerciseDashboardInfoGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DashboardDto>> {
        const queryParameters: any = {};

        if (requestParameters['yearWeek'] != null) {
            queryParameters['yearWeek'] = requestParameters['yearWeek'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/exercise/dashboard/info`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DashboardDtoFromJSON(jsonValue));
    }

    /**
     */
    async apiExerciseDashboardInfoGet(requestParameters: ApiExerciseDashboardInfoGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DashboardDto> {
        const response = await this.apiExerciseDashboardInfoGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiExerciseDashboardStreaksGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StreaksDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/exercise/dashboard/streaks`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StreaksDtoFromJSON(jsonValue));
    }

    /**
     */
    async apiExerciseDashboardStreaksGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StreaksDto> {
        const response = await this.apiExerciseDashboardStreaksGetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async apiExerciseGoalGetRaw(requestParameters: ApiExerciseGoalGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GoalDto>> {
        const queryParameters: any = {};

        if (requestParameters['yearWeek'] != null) {
            queryParameters['yearWeek'] = requestParameters['yearWeek'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/exercise/goal`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GoalDtoFromJSON(jsonValue));
    }

    /**
     */
    async apiExerciseGoalGet(requestParameters: ApiExerciseGoalGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GoalDto> {
        const response = await this.apiExerciseGoalGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiExerciseGoalPostRaw(requestParameters: ApiExerciseGoalPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['value'] == null) {
            throw new runtime.RequiredError(
                'value',
                'Required parameter "value" was null or undefined when calling apiExerciseGoalPost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['value'] != null) {
            queryParameters['value'] = requestParameters['value'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/exercise/goal`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiExerciseGoalPost(requestParameters: ApiExerciseGoalPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiExerciseGoalPostRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiExercisePostRaw(requestParameters: ApiExercisePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['exerciseDTO'] == null) {
            throw new runtime.RequiredError(
                'exerciseDTO',
                'Required parameter "exerciseDTO" was null or undefined when calling apiExercisePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/exercise`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ExerciseDTOToJSON(requestParameters['exerciseDTO']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiExercisePost(requestParameters: ApiExercisePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiExercisePostRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiExerciseStreakGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/exercise/streak`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async apiExerciseStreakGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.apiExerciseStreakGetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async apiExerciseWeekGetRaw(requestParameters: ApiExerciseWeekGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Exercise>>> {
        const queryParameters: any = {};

        if (requestParameters['yearWeek'] != null) {
            queryParameters['yearWeek'] = requestParameters['yearWeek'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/exercise/week`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ExerciseFromJSON));
    }

    /**
     */
    async apiExerciseWeekGet(requestParameters: ApiExerciseWeekGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Exercise>> {
        const response = await this.apiExerciseWeekGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
